import React, {useContext, useEffect, useRef, useState} from 'react'
import {IExpense, ITimesheet} from "../../../../models";
import {useSelector} from "react-redux";
import {PopupContext} from "../../../../App";
import {BlockToDuplicate, BlockToEdit, FixedTopEdit } from '../../Costs';
import {Translate} from "../../../../components/translate/Translate";
import { getApiLink } from './../../../../functions/getApiLink';
import {handleOpenContextMenu} from "../../../../functions/handleOpenContextMenu";
import { Link } from 'react-router-dom';
import getCookies from "../../../../functions/getCookie";

interface ICostsTableItemProps {
    item: IExpense,
    index: number
    itemToEdit: any
}

export const CostsTableItem: React.FC<ICostsTableItemProps> = ({item, index, itemToEdit}) => {

    const [isOpenContextMenu, setIsOpenContextMenu] = useState(false)
    const [menuPosition, setMenuPosition] = useState({})

    const chosenTimesheet: ITimesheet = useSelector((state: any) => state.toolkit.chosenTimesheet)
    const expenseList: IExpense[] = useSelector((state: any) => state.toolkit.expenses)

    const modalBlock: any = useRef(null)
    const rowBlock: any = useRef(null)

    useEffect(() => {

        const onClick = (e: any) => modalBlock.current.contains(e.target) || setIsOpenContextMenu(false);
        const onContext = (e: any) => rowBlock.current.contains(e.target) || setIsOpenContextMenu(false);

        document.addEventListener('click', onClick);
        document.addEventListener('contextmenu', onContext);
        return () => {
            document.removeEventListener('click', onClick);
            document.removeEventListener('contextmenu', onContext);
        }
    }, []);

    const isApprove = chosenTimesheet?.status === "approve"

    useEffect(() => {
        if (!isOpenContextMenu) {
            setTimeout(() => {
                setMenuPosition({
                    top: "auto",
                    left: "auto"
                })
            }, 300)
        }
    }, [isOpenContextMenu])

    const setPopup: any = useContext(PopupContext)
    const editTask: any = useContext(BlockToEdit)
    const duplicateTask: any = useContext(BlockToDuplicate)
    const setIsFixedEditBlock: any = useContext(FixedTopEdit)

    const handleEditTask = (data?: IExpense) => {
        editTask(item)
        duplicateTask({})
        setIsOpenContextMenu(false)
        setIsFixedEditBlock(true)
    }
    const handleRemoveTask = (data: IExpense) => {
        setPopup({popup: "remove-expense-popup", data})
        setIsOpenContextMenu(false)
    }
    const handleDuplicateTask = (data: IExpense) => {
        editTask({})
        duplicateTask(item)
        setIsFixedEditBlock(true)
        setIsOpenContextMenu(false)
    }

    const handleDeleteCheck = () => {
        setPopup({popup: 'delete-receipt', data: item})
    }

    // State for check file status
    const [checkFileStatus, setCheckFileStatus] = useState<'ok' | 'notfound' | 'loading' | null>(null);
    const [checkFileUrl, setCheckFileUrl] = useState<string | null>(null);

    useEffect(() => {
        if (!item.check_file) {
            setCheckFileStatus(null);
            setCheckFileUrl(null);
            return;
        }
        // Use backend proxy endpoint so frontend never calls production assets directly.
        const endpoint = getApiLink(`/api/expense/check/${item.id}/file/`);
        setCheckFileStatus('loading');
        setCheckFileUrl(endpoint);

        // Normalize raw media URL (avoid double /media/media/)
        const normalizeMediaUrl = (raw: string | null) => {
            if (!raw) return null;
            // strip leading slashes
            let p = raw.replace(/^\/+/, '');
            // if it already contains 'media/', ensure single 'media/' prefix
            if (p.startsWith('media/')) {
                return getApiLink('/' + p);
            }
            // otherwise assume it's a path relative to media
            return getApiLink('/media/' + p);
        }

        // Auth headers for fetch calls
        const token = getCookies('access_token_ces');
        const authHeaders: HeadersInit = token ? { Authorization: `Bearer ${token}` } : {};

        // First, try proxy endpoint (HEAD avoids downloading the file)
        fetch(endpoint, { method: 'HEAD', headers: authHeaders })
            .then(res => {
                console.log('Check file endpoint:', endpoint, 'status:', res.status);
                if (res.ok) {
                    setCheckFileStatus('ok');
                } else {
                    // Fallback: try normalized direct media URL (some records reference direct media paths)
                    const direct = normalizeMediaUrl(item.check_file ?? null);
                    if (!direct) {
                        setCheckFileStatus('notfound');
                        return;
                    }
                    fetch(direct, { method: 'HEAD' })
                        .then(r2 => {
                            console.log('Check file direct url:', direct, 'status:', r2.status);
                            if (r2.ok) setCheckFileStatus('ok');
                            else setCheckFileStatus('notfound');
                        })
                        .catch(() => setCheckFileStatus('notfound'))
                }
            })
            .catch(err => {
                console.log('Check file endpoint:', endpoint, 'error:', err);
                const direct = normalizeMediaUrl(item.check_file ?? null);
                if (!direct) {
                    setCheckFileStatus('notfound');
                    return;
                }
                fetch(direct, { method: 'HEAD' })
                    .then(r2 => {
                        console.log('Check file direct url:', direct, 'status:', r2.status);
                        if (r2.ok) setCheckFileStatus('ok');
                        else setCheckFileStatus('notfound');
                    })
                    .catch(() => setCheckFileStatus('notfound'))
            });
    }, [item.check_file, item.id]);

    return (
        <div className="section-table__row drop-down-2" ref={rowBlock} style={{border: itemToEdit?.id === item?.id ? "1px solid #FBC900" : ""}} onContextMenu={e => !isApprove && handleOpenContextMenu({e, isOpenContextMenu, setMenuPosition, setIsOpenContextMenu, height: 160, width: 165})}>
            <div className="section-table__param visible-on-mob">
                <span>
                    {expenseList.length - index}
                </span>
                <span>
                    {item.date.replaceAll(".", "/")}
                </span>
            </div>
            <div className="section-table__param visible-on-desktop is-center">
                {expenseList.length - index}
            </div>
            <div className="section-table__param visible-on-desktop is-center">
                {item.date.replaceAll(".", "/")}
            </div>
            <div className="section-table__param is-center">
                {item.project.name}
            </div>
            <div className="section-table__param">
                {item.project.description}
            </div>
            <div className="section-table__param is-center">
                {item.category.name}
            </div>
            <div className="section-table__param">
                {item.description}
            </div>
            <div className="section-table__param is-center">
                {item?.sum_in_currency?.toFixed(2)}
            </div>
            <div className="section-table__param is-center" style={{textTransform: "uppercase"}}>
                {item?.currency}
            </div>
            <div className="section-table__param is-center">
                {item?.sum?.toFixed(2)}
            </div>
            {/* Check file icon/logic */}
            <div className="section-table__param is-center section-table__param-checkbox">
                {item.check_file ? (
                    checkFileStatus === 'ok' ? (
                        <a href={checkFileUrl!} target="_blank" rel="noopener noreferrer">
                            <input type="checkbox" disabled checked={true}/>
                            <label>
                                <svg width="15" height="16" viewBox="0 0 15 16">
                                    <use xlinkHref="#check"></use>
                                </svg>
                            </label>
                        </a>
                    ) : checkFileStatus === 'notfound' ? (
                        <span style={{color: '#aaa', display: 'flex', alignItems: 'center', gap: 4}}>
                            <svg width="15" height="16" viewBox="0 0 15 16">
                                <use xlinkHref="#check"></use>
                            </svg>
                            <span><Translate>costs_page.table.file_not_found</Translate></span>
                        </span>
                    ) : (
                        <span style={{color: '#aaa'}}><Translate>costs_page.table.check_loading</Translate></span>
                    )
                ) : null}
            </div>

            <div className={"drop-down-2__block" + (isOpenContextMenu ? " active" : "")} ref={modalBlock}
                 style={menuPosition}>
                <ul className="drop-down-2__list">
                    <li>
                        <a onClick={_ => handleEditTask(item)} className="open-popup">
                            <svg width="15" height="16" viewBox="0 0 15 16">
                                <use xlinkHref="#edit"></use>
                            </svg>
                            <Translate>timesheet_page.popups.edit</Translate>
                        </a>
                    </li>
                    <li>
                        <a onClick={_ => handleDuplicateTask(item)} className="open-popup">
                            <svg width="15" height="16" viewBox="0 0 15 16">
                                <use xlinkHref="#copy"></use>
                            </svg>
                            <Translate>timesheet_page.popups.duplicate</Translate>
                        </a>
                    </li>
                    <li>
                        <a onClick={_ => handleRemoveTask(item)} className="open-popup">
                            <svg width="15" height="16" viewBox="0 0 15 16">
                                <use xlinkHref="#trash"></use>
                            </svg>
                            <Translate>timesheet_page.popups.delete</Translate>
                        </a>
                    </li>
                    {!!item.check_file && <li>
                        <a onClick={_ => handleDeleteCheck()} className="open-popup">
                            <svg width="15" height="16" viewBox="0 0 15 16">
                                <use xlinkHref="#trash"></use>
                            </svg>
                            <Translate>Delete receipt</Translate>
                        </a>
                    </li>}
                </ul>
            </div>
        </div>
    )
}
